import { z } from "zod";
import { channelObjectTypeIdSchema, channelRecordIdSchema, channelViewIdSchema, patchChannelObjectFieldInputSchema } from "./channels.js";
import { channelFeedSubjectParamsSchema, updateChannelPostCommandInputSchema, updateChannelFeedCommentCommandInputSchema } from "./channel-feed.js";
/** Public channel paths accept opaque IDs/slugs under the same contracts as their commands. */
export const twinChannelPathParamsSchema = z.object({
    channelId: updateChannelPostCommandInputSchema.shape.channelId.optional(),
    objectTypeId: channelObjectTypeIdSchema.optional(),
    recordId: channelRecordIdSchema.optional(),
    viewId: channelViewIdSchema.optional(),
    fieldKey: patchChannelObjectFieldInputSchema.shape.key.optional(),
    postId: updateChannelPostCommandInputSchema.shape.postId.optional(),
    commentId: updateChannelFeedCommentCommandInputSchema.shape.commentId.optional(),
    subjectType: channelFeedSubjectParamsSchema.shape.subjectType.optional(),
    subjectId: channelFeedSubjectParamsSchema.shape.subjectId.optional(),
}).strict();
